export default __webpack_public_path__ + "static/pixel-vertical-a5c14b28f2a98c52ee41acd542023354.svg";